/*global kakao*/
import React,{useEffect,useState} from 'react'
import axios from 'axios';
import { instance } from './common';

function KakaoMap({si_id}){
    const [data, setData] = useState([]);
    let obj = {si_id:si_id,}
    useEffect(() => {
        
      const fetchData = async () => {
        instance.post('/sigong/id',obj).then(function(res){
            setData(res.data);
        });
        
      };

      fetchData();

    }, []);

    console.log('kakao data : ', data)

    const script = document.createElement("script");
    script.async = true;
    script.src =
      "https://dapi.kakao.com/v2/maps/sdk.js?appkey=7910b4d9dce3356ca2566002b34ae33c&autoload=false";
    document.head.appendChild(script);

    if(data.length !=0){
        script.onload = () => {
            kakao.maps.load(() => {
                let container = document.getElementById("Mymap");
                let options = {
                center: new kakao.maps.LatLng(data[0].si_lat, data[0].si_long),
                level: 7
                };
    
                const map = new window.kakao.maps.Map(container, options);
                var mMarker = new kakao.maps.Marker({
                    position:  new kakao.maps.LatLng(data[0].si_lat, data[0].si_long),
                    map: map // 생성하면서 지도에 올립니다.
                });
            
            });
        };
    
    }

    const mapContent = {
        width: '100%',
        height: '100%',
    }
    return (
        <div id="Mymap" style={mapContent}></div>
    )
}


export default KakaoMap;